import { styled } from "styled-components";

export const StyledBullet = styled.svg`
  margin-right: 16px;
`;
